import {
  takeEvery,
  takeLatest,
  all,
  call,
  select,
  put
} from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'connected-react-router'
import { actions } from './ConfigSlice'
import { licenseTypes } from 'src/services/FW5ML/parsers/UserParser'
import { getPageFound } from 'src/features/config/utils'
import { arrayify } from 'src/utils'
import { getAnonArticleLimitSettings } from 'src/features/config/ConfigSelector'

function* addConfigRequest(services, { payload: { key, data = null } }) {
  const CatalogsRepository = services('CatalogsRepository')
  try {
    if (!data) {
      data = yield call([CatalogsRepository, 'getCatalog'], key)
    }
    yield put(actions.addConfigSuccess({ key, data }))
  } catch (e) {
    console.error(e)
    yield put(actions.addConfigError({ key, error: e.message }))
  }
}

function* updateConfigRequest(_, { payload: { key, data } }) {
  try {
    yield put(actions.updateConfigSuccess({ key, updatedData: data }))
  } catch (e) {
    console.error(e)
    yield put(actions.updateConfigError({ key, error: e.message }))
  }
}

function* handleRegisterModalURLChange(services, action) {
  const Session = services('Session')
  const user = yield call([Session, 'userLoad'])
  const { license = '' } = user

  // Reset Paywall/Register Modal showing up
  // Show register popup if the flow defines it for free users
  const anonArticleLimitSettings = yield select(getAnonArticleLimitSettings())
  const { registerPopUpFlow = {} } = anonArticleLimitSettings

  const showRegisterModalForFree = registerPopUpFlow?.show_for_free || false

  const showRegisterModalForAnonymous =
    registerPopUpFlow?.show_for_anon || false

  const pagesToInclude = registerPopUpFlow?.uri_path
    ? arrayify(registerPopUpFlow.uri_path)
    : []
  const pageFound = getPageFound(pagesToInclude)

  const showRegisterPaywall =
    (showRegisterModalForFree &&
      pageFound &&
      license === licenseTypes.LICENSE_FREE) ||
    (showRegisterModalForAnonymous && pageFound && !user?.profile_id) ||
    false

  yield put(
    actions.updateConfigRequest({
      key: 'account_settings',
      data: {
        showRegisterPaywall
      }
    })
  )
}

export default function* watchConfig(services) {
  yield all([
    takeEvery(actions.addConfigRequest, addConfigRequest, services),
    takeLatest(actions.updateConfigRequest, updateConfigRequest, services),
    takeLatest(LOCATION_CHANGE, handleRegisterModalURLChange, services),
    takeLatest(
      actions.getConfigRegisterModalValidation,
      handleRegisterModalURLChange,
      services
    )
  ])
}
